module.exports = __webpack_public_path__ + "static/media/background.8fa71fb2.png";